<template>
	<div class="bright container-fluid py-2">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0" id="bright-parent">
			<div class="col-md-8 pl-0">
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SALES" unit="B" div=1000000000 :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="WASTE" unit="M" div=1000000 :data="ytd.waste.rekap" itemcol="Info" valuecol="Value" comp=-1 url="/bright/sales"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<ListCompare title="SPD" unit="M" div=1000000 :data="ytd.sales.spd" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<ListCompare title="MARGIN" unit="%" :data="ytd.margin.rekap" itemcol="Info" valuecol="Value" url="/bright/sales"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<BarCard title="SALES YTD (B)" :data="ytd.sales.ytdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
					<div class="col-md-6">
						<BarCard title="SALES MTD (B)" :data="ytd.sales.mtdchart" :width="500" :height="280" url="/bright/sales"/>
					</div>
				</div>				
			</div>
			<div class="col-md-4 pr-0">
				<div class="row">
					<ListItem title="STORES BY AREA" prefix="AREA" :data="store.area" itemcol="SalesArea" valuecol="StoreCnt"/>
					<ListItem title="STORES BY PROVINCE" :data="store.province" itemcol="ProvinceName" valuecol="StoreCnt"/>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import Bright from '@/components/page/Bright.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'

export default{
	extends: Bright,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		Footer            
	},
    mounted()
	{
		this.loadYTD();
		this.loadStore();
		//this.displayParentContent()
		//this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'
    },
	data() {
		return {
			url: '',
		}
	},
	watch:{

	},
	computed: {
		currentRouteName() {
			return this.getUri()
		}
	},
    methods:{
		displayParentContent() {
            document.getElementById("bright-parent").style.display = "inline";
        },
		getUri() {
			let uriPath2 = window.location.pathname.split('/')
			console.log('url: '+ uriPath2)
		},
	},

}

</script>